import { FC } from 'react';
import { format } from 'date-fns';
import styled from 'styled-components';
import { Stack, Typography } from '@mui/material';
import { SmartToy } from '@mui/icons-material';
import { HeroConversationMessage } from '@vs-online-only-app/state';
import { UserAvatar } from '@vs-online-only-app/ui';
import useConversationMessage from '../../hooks/useConversationMessage';
import ChatBubble from './ChatBubble';

const GridWrapper = styled.div`
  display: grid;
  grid-template-columns: ${({ theme }) => theme.spacing(4)} 1fr;
  column-gap: ${({ theme }) => theme.spacing(1)};
`;

const BubbleWrapper = styled.div`
  grid-column: 2/3;
`;

type Props = {
  message: HeroConversationMessage;
};

export const ChatBotMessage: FC<Props> = ({ message }) => {
  const { isFirstInStack, isStacked, isLastInStack } =
    useConversationMessage(message);

  const hasAvatar = isFirstInStack || !isStacked;

  return (
    <GridWrapper>
      {hasAvatar && <UserAvatar icon={<SmartToy />} />}
      <BubbleWrapper>
        <ChatBubble
          maxWidthPercentage={75}
          direction="left"
          isLastInStack={isLastInStack}
          isFirstInStack={isFirstInStack}
          isStacked={isStacked}
          borderColor="secondary"
        >
          <Stack direction="row" gap={1} alignItems="flex-end">
            <Typography variant="body2">{message.body}</Typography>
            {message?.dateCreated && (
              <Typography
                variant="caption"
                color="textSecondary"
                sx={{ opacity: 0.5 }}
              >
                {format(message.dateCreated, 'HH:mm')}
              </Typography>
            )}
          </Stack>
        </ChatBubble>
      </BubbleWrapper>
    </GridWrapper>
  );
};
